<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import type { Counters } from '@autobid/ui/types/components/CarsList'
import { useFuelTypes } from '@autobid/ui/composables/auction/useFuelTypes'
import { injectFilterComposable } from '@autobid/ui/utils/carsList/injectFilterComposable'
import { inject } from 'vue'

interface Props {
  counters: Counters
}

defineProps<Props>()

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')

const { fuelTypesNoFilterCounters, fuelTypesToDisplay } = useFuelTypes(
  auctionStrapiData?.type === 'carList' ? 'auction' : 'searchList',
)
const useFilter = injectFilterComposable()
const {
  filters: { e17 },
} = useFilter()

function handleFilter(isAdding: boolean, value: number) {
  const currentValue = e17.value || []
  e17.value = isAdding
    ? [...currentValue, value]
    : currentValue.filter(el => el !== value)
}
</script>

<template>
  <common-filters-dropdown
    v-if="fuelTypesNoFilterCounters.atLeastOneExists"
    card-key="fuelType"
  >
    <template #title>
      {{ $t('cars-list.filters.fuel-type') }}
    </template>

    <template #content>
      <common-filters-checkboxes-wrapper class="!mt-0">
        <ElementsCheckbox
          v-for="fuelType in fuelTypesToDisplay"
          :key="fuelType.id"
          class="[&>*]:text-[#58585A]"
          :checked="Boolean(e17?.includes(fuelType.id))"
          :label-suffix="counters.e17?.[fuelType.id] ?? 0"
          :disabled="(counters.e17?.[fuelType.id] ?? 0) === 0"
          :label="fuelType.label"
          :small="true"
          @change="(isAdding: boolean) => handleFilter(isAdding, fuelType.id)"
        />
      </common-filters-checkboxes-wrapper>
    </template>
  </common-filters-dropdown>
</template>
